import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../utils/auth';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  // 如果正在加载用户认证状态，显示加载中
  if (loading) {
    return <div>加载中...</div>;
  }
  
  // 如果用户未认证，重定向到登录页
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  // 否则正常渲染子组件
  return children;
};

export default PrivateRoute; 